import core from "@homer.core/api";
import application from "@homer.core/application";
import isInstanceof from "@homer.utility/validator.isinstanceof";
import Request from "./request.js";
import token from "./token.js";

class Client extends core.Client {
    static base = `/${application.locale}/api`;

    constructor(base) {
        super(base || Client.base);
    }

    execute(request, endpoint, isRetry = false) {
        if (!isInstanceof(request, Request)) {
            throw new TypeError("Argument `request` must be of type `Request` from `@homer.api/homer`");
        }

        return super
            .execute(
                request,
                endpoint,
                !!(request.flags & Request.flag.isCacheable),
                !!(request.flags & Request.flag.attachCredentials),
                !!(request.flags & Request.flag.prioritize),
                !!(request.flags & Request.flag.suppressEvents),
            )
            .then(({ data }) => data)
            .catch((error) => {
                if (
                    request.flags & Request.flag.attachToken &&
                    error?.data?.data?.code === 401 &&
                    error?.data?.data?.message?.includes("token is not valid") &&
                    !isRetry
                ) {
                    void globalThis.demand.request("@apfelkiste/errorhandler").then(([errorHandler]) => {
                        errorHandler.handleMessage("token 1st try", { logData: { endpoint, request } });
                    });

                    return token.refresh(this).then(() => {
                        return request.clone(this).then((request) => {
                            return this.execute(request, endpoint, true);
                        });
                    });
                }

                if (isRetry) {
                    void globalThis.demand.request("@apfelkiste/errorhandler").then(([errorHandler]) => {
                        errorHandler.handleMessage("token 2nd try", { logData: { endpoint, request } });
                    });
                }

                if (error instanceof core.ResponseError) {
                    throw new globalThis.CustomError(
                        "api",
                        { text: error?.data?.data?.message || undefined, appendix: error?.data?.data?.appendix },
                        false,
                        error?.data,
                    );
                }

                throw error;
            });
    }

    get(endpoint, data = {}, flags) {
        return this.execute(new Request("GET", data, {}, flags, this), endpoint);
    }

    post(endpoint, data = {}, flags) {
        return this.execute(new Request("POST", data, {}, flags, this), endpoint);
    }
}

export default Client;
